import React, { useEffect } from "react";

export function useInputElementFocusOnMount(ref: React.RefObject<HTMLInputElement | null>) {
  useEffect(() => {
    const { current } = ref;

    if (current) {
      current.focus();
    }
  }, []);
}
